import React from 'react';
import { IconProps } from '../IconProps';
const SvgOffice = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
    <path
      d="M1.75 17a.75.75 0 01-.75-.75V4.412c0-.704.419-1.337 1.068-1.611l4.5-1.904a1.745 1.745 0 011.648.153c.491.325.783.871.783 1.459V4.25a.75.75 0 01-1.5 0V2.509a.245.245 0 00-.112-.209.24.24 0 00-.236-.021l-4.5 1.903a.25.25 0 00-.152.23V16.25a.75.75 0 01-.749.75z"
      fill="#200C05"
    />
    <path
      d="M15.25 15.5H15V7.75C15 6.785 14.215 6 13.25 6h-5.5C6.785 6 6 6.785 6 7.75v7.75H.75a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5zM10 13.25a.75.75 0 01-1.5 0v-.5a.75.75 0 011.5 0v.5zm0-3a.75.75 0 01-1.5 0v-.5a.75.75 0 011.5 0v.5zm2.5 3a.75.75 0 01-1.5 0v-.5a.75.75 0 011.5 0v.5zm0-3a.75.75 0 01-1.5 0v-.5a.75.75 0 011.5 0v.5z"
      fill="#200C05"
    />
  </svg>
);
export default SvgOffice;
